export const buildMenuTooltip = (tooltipText) => ({
  className: 'menuTooltip',
  content: tooltipText,
  popoverOptions: {
    constraints: [
      {
        popover: 'top center',
        attachment: 'bottom center',
      },
    ],
  },
  themeClass: 'white',
})

export default {
  buildMenuTooltip,
}
